import {MODEL_DATA} from './mutation-types';
import {axiosClient} from '../../../core/services/http.service';

export async function getMdmModel({commit}) {
  const {success, body} = await axiosClient.get('/api/dotdefinition');
  if (success) {
    commit(MODEL_DATA, body);
  }
}
